module.exports = __webpack_public_path__ + "static/media/nhs.fa7ee5d2.svg";